<template>
  <el-dropdown @visible-change="visibleChange">
    <div class="call-btn">
      <i class="el-icon el-icon-service"></i>
      <span>联系我们</span>
    </div>
    <el-dropdown-menu slot="dropdown" class="dropdown-menu" v-loading="loading">
      <el-dropdown-item class="dropdown-item" v-for="item in customerList" :key="item.UserID">
        <div class="item-left">
          <user-icon :logoPath="item.UserLogo"></user-icon>
          <div class="user-data">
            <p>{{item.CSName || item.UserName}}</p>
            <p>{{item.Phone}}</p>
          </div>
        </div>
        <el-button v-if="isClient" type="primary" size="small" plain @click="_goChat(item)">立即咨询</el-button>
      </el-dropdown-item>

      <el-dropdown-item class="dropdown-item" v-for="item in phoneList" :key="item">
        <div class="item-left">
          <img :src="phoneIcon" alt="" class="phone-icon">
          <span>{{item}}</span>
        </div>
      </el-dropdown-item>

    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import {CheckLibs} from '@digital-supply-chain/module'
import { ChatService, CompService } from '@/service';
import { Category } from '@/libs';
import {  decryptPhone } from "@/utils/utils";

import UserIcon from '@/components/icon/user-icon.vue';

const phoneIcon = require('../icon/phone.png');

export default {
  props: {
    compID: { default: '' },
    phone: { default: '' },
  },
  components: { UserIcon },
  data() {
    return {
      customerList: [],
      loading: false,

      phoneIcon,
      isClient: CheckLibs.isClient()
    }
  },
  computed: {
    phoneList() {
      return this.phone ? this.phone.split(',') : []
    }
  },
  methods: {
    visibleChange(bol) {
      if (bol && this.customerList.length <= 0) {
        this.getStaffcustomerlist();
      }
    },
    _goChat(value) {
      ChatService.StartRecent(Category.User, value.UserID)
    },
    async getStaffcustomerlist() {
      this.loading = true;
      const res = await CompService.GetPublicUsers(this.compID);
      this.loading = false;
      if (res) {
        res.forEach(item => {
          item.Phone = decryptPhone(item.PhoneEncrypt);
        })
        this.customerList = res || [];
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dropdown-menu{
  width: 260px;
  padding: 5px 10px;
  max-height: 375px;
  overflow-y: auto;
  /deep/ .dropdown-item{
    justify-content: space-between;
    border-bottom: 1px solid #EEEEEE;
    padding: 8px 0;
    display: flex;
    align-items: center;
  }
  .item-left{
    display: flex;
    align-items: center;
    img{
      width: 40px!important;
      height: 40px!important;
      margin-right: 6px;
    }
  }
  .user-data{
    p{
      margin: 0;
      color: #666666;
      font-size: 12px;
      line-height: 22px;
    }
    p:first-child{
      color: #242F57;
    }
  }
  .phone-icon{
    width: 40px;
    height: 40px;
  }
}

.call-btn{
  width: 130px;
  height: 36px;
  color: @a-color-active;
  background: #ffffff;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 6px;
  font-size: 14px;
  .el-icon{
    font-size: 16px;
    color: @a-color-active;
  }
  &.active{
    color: @a-color-active;
    background: #ffffff;
    
  }
}
.call-btn:hover{
  color: @a-color-active;
  background: #ffffff;
  .el-icon{
    color: @a-color-active;
  }
}
.el-icon{
  color: #ffffff;
  font-size: 24px;
  margin-right: 2px;
}
</style>